// export const API_KEY = 'AIzaSyBrtynsuiiyFNGUfdy9eA1xIk7HEkSFC10'

//mine
export const API_KEY = 'AIzaSyCRT-lKlJd2o5H8_lrrEPdDRH0Xf0B8Ak8'

//stan
// export const API_KEY = 'AIzaSyCLG7uBVBrs-BVglKXwoQwp0dtp2fgTjqE'

// export const API_KEY = 'AIzaSyAoFcrjGCHKAlzceAEaFMrpGM448i5raEM'




